import { useMemo } from "react";

import { RechartPieChartData } from "@helpers/charts";
import { classNames } from "@helpers/css";
import { pluralize } from "@helpers/string";

const EngagementSurveyQuestionBarChart = ({
  data,
  sorted,
  totalResponders,
}: {
  data: RechartPieChartData[];
  sorted?: boolean;
  totalResponders: number;
}) => {
  const sortedData = useMemo(
    () => (sorted ? data.sort((a, b) => b.value - a.value) : data),
    [data, sorted],
  );
  return (
    <div className="bg-gray-50 rounded-md p-6">
      <div className="flex flex-col gap-4">
        {sortedData.map((entry) => {
          const percentage = Math.round((entry.value / totalResponders) * 100);
          return (
            <div className="flex items-center gap-4" key={entry.name}>
              <div className="w-52 text-ellipsis overflow-hidden text-nowrap">
                {entry.name}
              </div>
              <div className="grow">
                <div className="relative w-full h-7">
                  <div className="absolute inset-0 bg-gray-200 rounded-md" />

                  <div
                    className={classNames(
                      "absolute inset-0 origin-left",
                      percentage < 100 && "rounded-s-md",
                      percentage >= 100 && "rounded-md",
                    )}
                    style={{
                      width: `${percentage}%`,
                      backgroundColor: entry.color,
                    }}
                  />

                  <div className="absolute inset-0 origin-left text-white font-semibold h-7 px-2 flex items-center text-sm">
                    {percentage}%
                  </div>
                </div>
              </div>
              <div className="w-24 text-right text-gray-500 text-sm">
                {`${entry.value} ${pluralize("response", entry.value)}`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EngagementSurveyQuestionBarChart;
